<script setup>
import { register } from 'swiper/element/bundle';

defineProps({
    slideWidth: {
        type: String,
        default: '200px',
    },
    options: {
        type: Object,
        default: () => ({}),
    },
    slides: {
        type: Array,
        default: () => [],
    }
});

register();

</script>

<template>
    <swiper-container v-bind="options">
        <swiper-slide v-for="(slide, index) in slides" :key="index" :style="`width: ${slideWidth}`">
            <slot :slide="slide" />
        </swiper-slide>
    </swiper-container>
</template>